import React, { useEffect, useState, useRef } from 'react'
import Helmet from 'react-helmet'
import { BrowserUtils } from '../utils/siteUtils'

export const ExternalScriptHead = ({ externalScripts, appScripts, hasGo, initPath, globalState, updateGlobalState }) => {
  const appReady = true
  const { environment, pageReady } = globalState
  useObserverHook(pageReady, updateGlobalState, hasGo, initPath)
  const [externalScriptsHookSrc] = useExternalScriptsHook(externalScripts, globalState, updateGlobalState)
  const [appScriptsHookSrc] = useExternalScriptsHook(appScripts, globalState, updateGlobalState)
  return (
    <Helmet>
      {appReady && appScripts.map(externalScript => <script key={externalScript} id={externalScript + 'Src'} src={environment[externalScript + 'Src']} defer />)}
      {appReady && <script defer>{appScriptsHookSrc}</script>}
      {pageReady && externalScripts.map(externalScript => <script key={externalScript} id={externalScript + 'Src'} src={environment[externalScript + 'Src']} defer />)}
      {pageReady && <script defer>{externalScriptsHookSrc}</script>}
    </Helmet>
  )
}

const getExternalScriptHook = externalScript => `
  if(!window.ICO_${externalScript}IsSet) {
    window.ICO_${externalScript}IsSet = true
    var ${externalScript}Src = document.getElementById('${externalScript}Src')
    if(!${externalScript}Src) console.log('No ${externalScript}Src script identified for the environment!')
    else ${externalScript}Src.onload = function() {
      if (window.ICO_set${externalScript}Ready) window.ICO_set${externalScript}Ready()
      else window.ICO_${externalScript}Ready = true
    }
  }
`

const getExternalScriptsHookSrc = externalScripts => externalScripts.map(getExternalScriptHook).join('\n')

export const useExternalScriptsHook = (externalScripts, globalState, updateGlobalState) => {
  const [externalScriptsHookSrc, setExternalScriptsHookSrc] = useState(getExternalScriptsHookSrc(externalScripts))
  useEffect(() => {
    externalScripts.forEach(externalScript => {
      if (!globalState[externalScript + 'Ready']) {
        const setScriptReady = () => {
          if (!globalState[externalScript + 'Ready']) {
            console.log('Successfully loaded ' + externalScript + ' script.')
            updateGlobalState({ [externalScript + 'Ready']: true })
          }
        }
        updateGlobalState({ ['analyticsReady']: true }) // remove Adobe tagging.
        if (window['ICO_' + externalScript + 'Ready']) setScriptReady()
        else window['ICO_set' + externalScript + 'Ready'] = setScriptReady
      }
    })
  }, [externalScripts, globalState, updateGlobalState])
  return [externalScriptsHookSrc, setExternalScriptsHookSrc]
}

let globalAppReady = false
let globalPageReady = false
let globalInteractionReady = false
const events = ['mousemove', 'mousedown', 'keypress', 'DOMMouseScroll', 'mousewheel', 'touchstart', 'touchmove', 'MSPointerMove']
const useObserverHook = (pageReady, updateGlobalState, hasGo, initPath) => {
  useEffect(() => {
    if (!globalAppReady) {
      globalAppReady = true
      updateGlobalState({ appReady: true })
    }
    if (!hasGo) {
      // setInteractionReady directly if no observer is wanted, however performance degrade
      if (!globalPageReady) {
        globalPageReady = true
        updateGlobalState({ pageReady: true })
      }
    }
    const setInteractionReady = () => {
      if (!globalInteractionReady) {
        events.forEach(event => window.removeEventListener(event, setInteractionReady, false))
        globalPageReady = true
        globalInteractionReady = true
        updateGlobalState({ pageReady: true, interactionReady: true })
      }
    }
    if (!globalInteractionReady) {
      events.forEach(event => window.addEventListener(event, setInteractionReady, false))
    }
    return () => {
      events.forEach(event => window.removeEventListener(event, setInteractionReady, false))
    }
  }, [pageReady, updateGlobalState, hasGo, initPath])

  const timeout = useRef(null)
  useEffect(() => {
    timeout.current = setTimeout(() => {
      if (!globalPageReady) {
        globalPageReady = true
        updateGlobalState({ pageReady: true })
      }
    }, 1000)
    return () => {
      clearTimeout(timeout.current)
    }
  }, [pageReady, updateGlobalState, initPath])
}
